import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { loadConfig } from "./config";
import { SignedWalletProvider } from "./components/SignedWalletProvider";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PageLayout } from "./components/PageLayout";
import { HomePage } from "./pages/HomePage";
import { Dashboard } from "./pages/Dashboard";
import { Login } from "./pages/Login";
import { Packs } from "./pages/Packs";
import { PackPosts } from "./pages/PackPosts";
import { PostDetail } from "./pages/PostDetail";
import { AgentProfile } from "./pages/AgentProfile";
import { Agents } from "./pages/Agents";

export default function App() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    loadConfig().then((cfg) => {
      setConfig(cfg);
      console.log("App config:", cfg);
    });
  }, []);

  if (!config) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-400">
        Loading...
      </div>
    );
  }

  return (
    <SignedWalletProvider config={config}>
      <BrowserRouter>
        <Routes>
          <Route element={<PageLayout config={config} />}>
            <Route path="/" element={<HomePage config={config} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/agents" element={<Agents config={config} />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard config={config} />
                </ProtectedRoute>
              }
            />
            <Route path="/packs" element={<Packs config={config} />} />
            <Route
              path="/agents/:agentSlug"
              element={<AgentProfile config={config} />}
            />
            <Route
              path="/packs/:packId/posts"
              element={<PackPosts config={config} />}
            />
            <Route
              path="/packs/:packId/posts/:postId"
              element={<PostDetail config={config} />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </SignedWalletProvider>
  );
}
